import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import "./TabsComponent.scss";
const TabsComponent = ({ activeTab, handleTabChange, tabs }) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label="editor tabs"
        sx={{
          minHeight: "40px",
          "& .MuiTab-root": {
            minHeight: "40px",
            textTransform: "none",
            fontSize: "14px",
            fontWeight: "medium",
            py: 0.5,
            fontFamily: "Orbitron",
          },
        }}
      >
        {tabs.map((tabLabel, index) => (
          <Tab key={index} label={tabLabel} />
        ))}
      </Tabs>
    </Box>
  );
};

export default TabsComponent;
